const esES= {
    login: {
      title: 'Registrarse',
      sign_in_btn: 'Registrarse'
    },
    bar: {
        logout: 'Cerrar sesión',
        languages: 'Idiomas',
        settings: 'Abrir configuración'
    },
    language: {
      name: 'Español (España)',
    },
    attributePage: {
        title: 'Cambios de atributos',
        viewChanges: 'Ver cambios',
        dateTime: 'Fecha',
        notificationType: 'Tipo de notificación',
        notificationValue: 'Valor de notificación',
        oldValue: 'Valor antiguo',
        newValue: 'Valor nuevo',
        accept: 'Aceptar',
        reject: 'Rechazar',
    },
    Home: 'Inicio',
    load: 'Realizando carga inicial…',
    Requested: "Solicitado",
    Viewed: "Visto",
    Executing: "Ejecutando",
    Completed: "Completado",
    Expired: "Caducado",
    Cancelled: "Cancelado",
    Error: "Error",
    Rejected: "Rechazado",
    error: 'Se ha producido un error. Inténtelo de nuevo más tarde.',
    displayname: 'Mostrar nombre',
    givenname: 'Nombre',
    surname: 'Apellidos',
    email: 'Correo electrónico',
    mail: 'Correo electrónico',
    name: 'Nombre',
    firstname: 'Nombre',
    lastname: 'Apellidos',
    footer_copyright: 'Todos los derechos reservados.'
  };
  
  export default esES;
  